import React from "react";
import AllRoutes from "./AllRoutes";

const MainRoute: React.FC = () => {
	return (
		<div>
			<AllRoutes />
		</div>
	);
};

export default MainRoute;
